export default {
	filterArr: [
		{
			title: '统计条件',
			filterList: [
				{
					key: 'dateSection',
					type: 'date',
					keyWord: '推送时间',
					icon: 'icon-shijian',
					datePickerType: 'daterange',
					format: 'yyyy-MM-dd',
					valueFormat: 'yyyy-MM-dd',
					clearable: false,
				},
				{
					key: 'receiveNumber',
					keyWord: '手机号',
					clearable: true,
				},
			],
		},
	],
	columns: [
		{
			key: 'tenantName',
			name: '租户',
			tooltip: true,
		},
		{
			key: 'deviceTypeName',
			name: '表类型',
			tooltip: true,
		},
		{
			key: 'pushTime',
			name: '推送时间',
			width: 180,
			tooltip: true,
		},
		{
			key: 'eventName',
			name: '告警类型',
			width: 140,
			tooltip: true,
		},
		{
			key: 'smsContent',
			name: '短信内容',
			minWidth: 240,
			tooltip: true,
		},
		{
			key: 'receiveNumber',
			name: '手机号',
			width: 140,
			tooltip: true,
		},
	],
	header: {
		pic: 'statistical-analysis',
		title: '短信推送报表',
		desc: '对短信告警推送记录进行查询和导出。',
	},
}
